export function NotFound() {
  return (
    <div
      className={`min-h-screen bg-gray-100 flex flex-col transition-opacity duration-500`}
    >
      <div className="w-full md:w-[480px] mx-auto bg-white min-h-screen md:rounded-t-[32px] md:min-h-[calc(100vh-24px)] md:mt-[24px] md:h-[calc(100vh-24px) md:shadow-xs flex flex-col">
        {/* Scrollable content area */}
        <div className="flex-1 overflow-y-auto">
          <div className="pt-4 pb-6">
            <div className="flex items-center border-b px-6 pb-4 border-[#EBEEF4] justify-between mb-5">
              <div>
                <svg
                  width="83"
                  height="16"
                  viewBox="0 0 83 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_297_19995)">
                    <path
                      d="M5.90069 7.28974H9.12183V3.99692H5.90069V0.0902506L5.73953 0.0256348L0.00634766 4.93281V7.28974H2.5189V15.7482H9.44364V12.4554H5.90069V7.28974Z"
                      fill="black"
                    />
                    <path
                      d="M19.9436 5.06614C18.8871 4.1328 17.7743 3.77075 16.4651 3.77075C13.1478 3.77075 10.8608 6.2887 10.8608 9.87229C10.8608 13.4559 13.1478 15.9738 16.4651 15.9738C17.7743 15.9738 18.8871 15.6123 19.9436 14.6784V15.7477H23.1642V3.99639H19.9436V5.06562V5.06614ZM17.1092 13.0364C15.2091 13.0364 14.1782 11.6482 14.1782 9.87229C14.1782 8.09639 15.2091 6.70819 17.1092 6.70819C19.0094 6.70819 20.008 8.09639 20.008 9.87229C20.008 11.6482 18.9771 13.0364 17.1092 13.0364Z"
                      fill="black"
                    />
                    <path
                      d="M65.2934 5.17635V3.93225H61.9111V15.7481H65.2934V8.49584L69.2227 7.06353V3.7384L69.0937 3.64148L65.2934 5.17635Z"
                      fill="black"
                    />
                    <path
                      d="M55.6306 5.06614C54.5741 4.1328 53.4613 3.77075 52.1521 3.77075C48.8348 3.77075 46.5479 6.2887 46.5479 9.87229C46.5479 13.4559 48.8348 15.9738 52.1521 15.9738C53.4613 15.9738 54.5741 15.6123 55.6306 14.6784V15.7477H58.8512V3.99639H55.6306V5.06562V5.06614ZM52.7962 13.0364C50.8961 13.0364 49.8652 11.6482 49.8652 9.87229C49.8652 8.09639 50.8961 6.70819 52.7962 6.70819C54.6964 6.70819 55.6951 8.09639 55.6951 9.87229C55.6951 11.6482 54.6641 13.0364 52.7962 13.0364Z"
                      fill="black"
                    />
                    <path
                      d="M26.3853 3.99695V15.7482H29.7676V7.28977H33.5678V15.7482H36.9496V7.28977H40.7504V15.7482H44.1322V3.99695H26.3853Z"
                      fill="black"
                    />
                    <path
                      d="M79.1433 3.99691V5.06614C78.0868 4.1328 76.974 3.77075 75.6648 3.77075C72.3475 3.77075 70.0605 6.2887 70.0605 9.87229C70.0605 13.4559 72.3475 15.9738 75.6648 15.9738C76.974 15.9738 78.0868 15.6123 79.1433 14.6784V15.7477H82.3639V3.99639H79.1433V3.99691ZM76.3089 13.0364C74.4088 13.0364 73.3779 11.6482 73.3779 9.87229C73.3779 8.09639 74.4088 6.70819 76.3089 6.70819C78.2091 6.70819 79.2078 8.09639 79.2078 9.87229C79.2078 11.6482 78.1768 13.0364 76.3089 13.0364Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_297_19995">
                      <rect width="82.3704" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>

            <div className="h-full px-6 grid place-items-center">
              <h2 className="text-[24px] px-6 font-semibold text-gray-900 mb-6">
                404
              </h2>
              <p className="text-gray-500">Page not found</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
